module.exports = __webpack_public_path__ + "img/right-more-8.9556ec94.png";